import {
  requestRealtorAuthLogin,
  requestRealtorAuthRegister,
} from "@/utils/authApi";
import { bindSalesAttribution } from "@/utils/salesAttribution";

// NZSC-3212: 공인중개사 공용 아이디/비밀번호 자체 가입·로그인.
// BE 응답 envelope 가 { code, message, session, userNo } 로 session 이 최상위에 내려온다
// (apiWrapper.callPostApi 는 res.data.data 만 반환하므로 session 이 유실됨).
// 기존 카카오 로그인 acRequestRealtorLogin 과 동일하게 raw response.data 를 직접 읽는다.
// www에서는 동일 오리진 인증 프록시를 사용해 http-only refresh 쿠키를 www에 저장한다.
export const state = {};

export const mutations = {};

export const actions = {
  /**
   * 공인중개사 자체 회원가입 (사무소당 공용 아이디/비밀번호)
   * @param {Object} payload { name, biz_no, phone, loginId, password }
   * @returns {Object|false} 성공 시 response.data ({ code:0, session, userNo }), 실패 시 false
   */
  async acRealtorAuthRegister(_, payload) {
    try {
      const response = await requestRealtorAuthRegister(payload);
      if (response.data?.session) {
        window.localStorage.setItem("naezip_to_ac_se", response.data.session);
        void bindSalesAttribution(response.data.session);
      }
      return response.data;
    } catch (error) {
      return false;
    }
  },

  /**
   * 공인중개사 자체 로그인
   * @param {Object} payload { loginId, password }
   * @returns {Object|false} 성공 시 response.data ({ code:0, session }), 실패(401 등) 시 false
   */
  async acRealtorAuthLogin(_, { loginId, password }) {
    try {
      const response = await requestRealtorAuthLogin({ loginId, password });
      if (response.data?.session) {
        window.localStorage.setItem("naezip_to_ac_se", response.data.session);
        void bindSalesAttribution(response.data.session);
      }
      return response.data;
    } catch (error) {
      return false;
    }
  },
};

export const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
